module.exports = __webpack_public_path__ + "img/IAHPC.cc7d582d.png";